import { useEffect, useRef } from 'react';
import { useEditorStore } from '../stores/editorStore';
import { useSettingsStore } from '../stores/settingsStore';

export const useAutoSave = () => {
  const { activeDocument, saveToLocalStorage } = useEditorStore();
  const { autoSave, autoSaveInterval } = useSettingsStore();
  const intervalRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    if (autoSave && activeDocument) {
      intervalRef.current = setInterval(() => {
        saveToLocalStorage();
      }, autoSaveInterval);
    }

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, [autoSave, autoSaveInterval, activeDocument, saveToLocalStorage]);

  const manualSave = () => {
    saveToLocalStorage();
  };

  return { manualSave };
};